import { Timestamp, timestampDate } from '@bufbuild/protobuf/wkt'

import { useIntervalCounter } from '@/hooks/use-interval-counter'

import { timeSince } from '@/lib/date/date'

type TimelineItemProps = {
  label: string
  lastUpdated?: Timestamp
  showLastUpdated?: boolean
}

export const TimelineItem = ({ label, lastUpdated, showLastUpdated }: TimelineItemProps) => {
  const { unit, value } = useIntervalCounter(Boolean(showLastUpdated), 1000, {
    calculateValue: () => timeSince(lastUpdated ? timestampDate(lastUpdated) : new Date()),
    hasChanged: (prev, next) => prev.unit !== next.unit || prev.value !== next.value,
  })

  return (
    <div className='flex items-center justify-between gap-3'>
      {label}
      {showLastUpdated && (
        <div className='text-main-foreground-placeholder text-body-small'>{`${value} ${unit}`}</div>
      )}
    </div>
  )
}
